<h2 mat-dialog-title>Edito Ndeshjen</h2>
<mat-dialog-content class="mat-typography">
  <div style="display: flex; gap: 1rem; margin-top: 10px">
    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>{{'Game Date' | translate}}</mat-label>
      <input [(ngModel)]="match.gameDate" [matDatepicker]="picker" matInput name="gameDate" required/>
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Koha e ndeshjes</mat-label>
      <input [(ngModel)]="match.gameTime" matInput name="gameTime" required type="time"/>
    </mat-form-field>
  </div>

  <div style="display: flex; gap: 1rem;">
    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Ekipi vendase</mat-label>
      <input [(ngModel)]="match.homeTeamName" disabled matInput/>
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Ekipi mysafire</mat-label>
      <input [(ngModel)]="match.awayTeamName" disabled matInput/>
    </mat-form-field>
  </div>

  <div style="display: flex; gap: 1rem;">
    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Rezultati i ekipit vendas</mat-label>
      <input [(ngModel)]="match.homeTeamScore" [disabled]="match.status === 'UPCOMING'" [min]="0" matInput
             name="homeTeamScore" required type="number"/>
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Rezultati i ekipit mysafire</mat-label>
      <input [(ngModel)]="match.awayTeamScore" [disabled]="match.status === 'UPCOMING'" [min]="0" matInput
             name="awayTeamScore" required type="number"/>
    </mat-form-field>
  </div>

  <div style="display: flex; gap: 1rem;">
    <mat-form-field appearance="outline" style="width: 265px">
      <mat-label>{{'Status' | translate}}</mat-label>
      <mat-select [(ngModel)]="match.status" name="status">
        <mat-option *ngFor="let status of matchStatuses" [value]="status">
          {{ status }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-dialog-actions align="end">
    <button (click)="close()" mat-button>{{'Cancel' | translate}}</button>
    <button (click)="saveChanges()" [disabled]="isSaveDisabled()" color="primary" mat-raised-button>
      {{'Update' | translate}}
    </button>
  </mat-dialog-actions>

